import { render, staticRenderFns } from "./ScoreCardItemV3.vue?vue&type=template&id=437f4114&scoped=true&"
import script from "./ScoreCardItemV3.vue?vue&type=script&lang=js&"
export * from "./ScoreCardItemV3.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardItemV3.vue?vue&type=style&index=0&id=437f4114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f4114",
  null
  
)

export default component.exports